import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "default11": "switch-81d9d7e1-default11-WXUgJq",
  "default7": "switch-81d9d7e1-default7-WXUgJq",
  "xwide12": "switch-81d9d7e1-xwide12-WXUgJq",
  "wideOffset10": "switch-81d9d7e1-wideOffset10-WXUgJq",
  "defaultOffset10": "switch-81d9d7e1-defaultOffset10-WXUgJq",
  "defaultOffset2": "switch-81d9d7e1-defaultOffset2-WXUgJq",
  "default5": "switch-81d9d7e1-default5-WXUgJq",
  "confinedOffset7": "switch-81d9d7e1-confinedOffset7-WXUgJq",
  "wide12": "switch-81d9d7e1-wide12-WXUgJq",
  "xwideOffset3": "switch-81d9d7e1-xwideOffset3-WXUgJq",
  "confined7": "switch-81d9d7e1-confined7-WXUgJq",
  "xwide3": "switch-81d9d7e1-xwide3-WXUgJq",
  "xwideOffset0": "switch-81d9d7e1-xwideOffset0-WXUgJq",
  "wideOffset1": "switch-81d9d7e1-wideOffset1-WXUgJq",
  "defaultOffset5": "switch-81d9d7e1-defaultOffset5-WXUgJq",
  "tiny3": "switch-81d9d7e1-tiny3-WXUgJq",
  "tiny0": "switch-81d9d7e1-tiny0-WXUgJq",
  "tiny7": "switch-81d9d7e1-tiny7-WXUgJq",
  "confinedOffset11": "switch-81d9d7e1-confinedOffset11-WXUgJq",
  "tinyOffset4": "switch-81d9d7e1-tinyOffset4-WXUgJq",
  "xwide7": "switch-81d9d7e1-xwide7-WXUgJq",
  "tinyOffset7": "switch-81d9d7e1-tinyOffset7-WXUgJq",
  "tinyOffset5": "switch-81d9d7e1-tinyOffset5-WXUgJq",
  "xwideOffset8": "switch-81d9d7e1-xwideOffset8-WXUgJq",
  "wide5": "switch-81d9d7e1-wide5-WXUgJq",
  "defaultOffset1": "switch-81d9d7e1-defaultOffset1-WXUgJq",
  "tiny10": "switch-81d9d7e1-tiny10-WXUgJq",
  "wideOffset9": "switch-81d9d7e1-wideOffset9-WXUgJq",
  "wide1": "switch-81d9d7e1-wide1-WXUgJq",
  "xwide4": "switch-81d9d7e1-xwide4-WXUgJq",
  "tinyOffset9": "switch-81d9d7e1-tinyOffset9-WXUgJq",
  "wide11": "switch-81d9d7e1-wide11-WXUgJq",
  "default3": "switch-81d9d7e1-default3-WXUgJq",
  "default12": "switch-81d9d7e1-default12-WXUgJq",
  "wideOffset2": "switch-81d9d7e1-wideOffset2-WXUgJq",
  "defaultOffset9": "switch-81d9d7e1-defaultOffset9-WXUgJq",
  "tinyOffset8": "switch-81d9d7e1-tinyOffset8-WXUgJq",
  "xwide6": "switch-81d9d7e1-xwide6-WXUgJq",
  "confinedOffset0": "switch-81d9d7e1-confinedOffset0-WXUgJq",
  "tinyOffset10": "switch-81d9d7e1-tinyOffset10-WXUgJq",
  "wideOffset5": "switch-81d9d7e1-wideOffset5-WXUgJq",
  "tiny9": "switch-81d9d7e1-tiny9-WXUgJq",
  "wide9": "switch-81d9d7e1-wide9-WXUgJq",
  "default1": "switch-81d9d7e1-default1-WXUgJq",
  "gridContainer": "switch-81d9d7e1-gridContainer-WXUgJq",
  "xwideOffset1": "switch-81d9d7e1-xwideOffset1-WXUgJq",
  "xwideOffset2": "switch-81d9d7e1-xwideOffset2-WXUgJq",
  "xwideOffset7": "switch-81d9d7e1-xwideOffset7-WXUgJq",
  "wide2": "switch-81d9d7e1-wide2-WXUgJq",
  "tiny11": "switch-81d9d7e1-tiny11-WXUgJq",
  "confined9": "switch-81d9d7e1-confined9-WXUgJq",
  "wide0": "switch-81d9d7e1-wide0-WXUgJq",
  "wide7": "switch-81d9d7e1-wide7-WXUgJq",
  "xwide2": "switch-81d9d7e1-xwide2-WXUgJq",
  "wideOffset3": "switch-81d9d7e1-wideOffset3-WXUgJq",
  "grid": "switch-81d9d7e1-grid-WXUgJq",
  "confinedOffset1": "switch-81d9d7e1-confinedOffset1-WXUgJq",
  "wideOffset7": "switch-81d9d7e1-wideOffset7-WXUgJq",
  "default8": "switch-81d9d7e1-default8-WXUgJq",
  "defaultOffset3": "switch-81d9d7e1-defaultOffset3-WXUgJq",
  "wide6": "switch-81d9d7e1-wide6-WXUgJq",
  "xwideOffset9": "switch-81d9d7e1-xwideOffset9-WXUgJq",
  "xwideOffset11": "switch-81d9d7e1-xwideOffset11-WXUgJq",
  "row": "switch-81d9d7e1-row-WXUgJq",
  "defaultOffset4": "switch-81d9d7e1-defaultOffset4-WXUgJq",
  "confined6": "switch-81d9d7e1-confined6-WXUgJq",
  "xwideOffset5": "switch-81d9d7e1-xwideOffset5-WXUgJq",
  "tiny6": "switch-81d9d7e1-tiny6-WXUgJq",
  "xwideOffset10": "switch-81d9d7e1-xwideOffset10-WXUgJq",
  "confinedOffset2": "switch-81d9d7e1-confinedOffset2-WXUgJq",
  "xwide10": "switch-81d9d7e1-xwide10-WXUgJq",
  "tiny5": "switch-81d9d7e1-tiny5-WXUgJq",
  "standardGridContainer": "switch-81d9d7e1-standardGridContainer-WXUgJq",
  "xwideOffset4": "switch-81d9d7e1-xwideOffset4-WXUgJq",
  "confined5": "switch-81d9d7e1-confined5-WXUgJq",
  "confinedOffset6": "switch-81d9d7e1-confinedOffset6-WXUgJq",
  "xwide5": "switch-81d9d7e1-xwide5-WXUgJq",
  "tiny4": "switch-81d9d7e1-tiny4-WXUgJq",
  "wide4": "switch-81d9d7e1-wide4-WXUgJq",
  "wideOffset0": "switch-81d9d7e1-wideOffset0-WXUgJq",
  "tinyOffset6": "switch-81d9d7e1-tinyOffset6-WXUgJq",
  "wideOffset6": "switch-81d9d7e1-wideOffset6-WXUgJq",
  "xwide0": "switch-81d9d7e1-xwide0-WXUgJq",
  "armstrongGridContainer": "switch-81d9d7e1-armstrongGridContainer-WXUgJq",
  "default10": "switch-81d9d7e1-default10-WXUgJq",
  "confined10": "switch-81d9d7e1-confined10-WXUgJq",
  "confinedOffset3": "switch-81d9d7e1-confinedOffset3-WXUgJq",
  "wide8": "switch-81d9d7e1-wide8-WXUgJq",
  "wideOffset8": "switch-81d9d7e1-wideOffset8-WXUgJq",
  "xwide1": "switch-81d9d7e1-xwide1-WXUgJq",
  "xwide9": "switch-81d9d7e1-xwide9-WXUgJq",
  "confinedOffset8": "switch-81d9d7e1-confinedOffset8-WXUgJq",
  "col": "switch-81d9d7e1-col-WXUgJq",
  "tinyOffset2": "switch-81d9d7e1-tinyOffset2-WXUgJq",
  "wide10": "switch-81d9d7e1-wide10-WXUgJq",
  "xwide11": "switch-81d9d7e1-xwide11-WXUgJq",
  "confined8": "switch-81d9d7e1-confined8-WXUgJq",
  "wideOffset4": "switch-81d9d7e1-wideOffset4-WXUgJq",
  "confinedOffset9": "switch-81d9d7e1-confinedOffset9-WXUgJq",
  "confinedOffset10": "switch-81d9d7e1-confinedOffset10-WXUgJq",
  "confinedOffset5": "switch-81d9d7e1-confinedOffset5-WXUgJq",
  "xwideOffset6": "switch-81d9d7e1-xwideOffset6-WXUgJq",
  "default9": "switch-81d9d7e1-default9-WXUgJq",
  "tinyOffset3": "switch-81d9d7e1-tinyOffset3-WXUgJq",
  "default4": "switch-81d9d7e1-default4-WXUgJq",
  "confined11": "switch-81d9d7e1-confined11-WXUgJq",
  "confined4": "switch-81d9d7e1-confined4-WXUgJq",
  "confined3": "switch-81d9d7e1-confined3-WXUgJq",
  "confined2": "switch-81d9d7e1-confined2-WXUgJq",
  "tiny2": "switch-81d9d7e1-tiny2-WXUgJq",
  "wideGridContainer": "switch-81d9d7e1-wideGridContainer-WXUgJq",
  "defaultOffset11": "switch-81d9d7e1-defaultOffset11-WXUgJq",
  "tinyOffset1": "switch-81d9d7e1-tinyOffset1-WXUgJq",
  "confined0": "switch-81d9d7e1-confined0-WXUgJq",
  "xwide8": "switch-81d9d7e1-xwide8-WXUgJq",
  "confined12": "switch-81d9d7e1-confined12-WXUgJq",
  "tinyOffset11": "switch-81d9d7e1-tinyOffset11-WXUgJq",
  "defaultOffset8": "switch-81d9d7e1-defaultOffset8-WXUgJq",
  "wide3": "switch-81d9d7e1-wide3-WXUgJq",
  "tiny1": "switch-81d9d7e1-tiny1-WXUgJq",
  "default6": "switch-81d9d7e1-default6-WXUgJq",
  "default2": "switch-81d9d7e1-default2-WXUgJq",
  "defaultOffset6": "switch-81d9d7e1-defaultOffset6-WXUgJq",
  "tinyOffset0": "switch-81d9d7e1-tinyOffset0-WXUgJq",
  "default0": "switch-81d9d7e1-default0-WXUgJq",
  "defaultOffset7": "switch-81d9d7e1-defaultOffset7-WXUgJq",
  "wideOffset11": "switch-81d9d7e1-wideOffset11-WXUgJq",
  "tiny12": "switch-81d9d7e1-tiny12-WXUgJq",
  "confined1": "switch-81d9d7e1-confined1-WXUgJq",
  "confinedOffset4": "switch-81d9d7e1-confinedOffset4-WXUgJq",
  "tiny8": "switch-81d9d7e1-tiny8-WXUgJq"
};